/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Actions_DeleteInputs */

const es_settings_files_actions_delete = /** @type {(inputs: Settings_Files_Actions_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const en_settings_files_actions_delete = /** @type {(inputs: Settings_Files_Actions_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Settings_Files_Actions_DeleteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_actions_delete = /** @type {((inputs?: Settings_Files_Actions_DeleteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Actions_DeleteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_actions_delete(inputs)
	return en_settings_files_actions_delete(inputs)
});
export { settings_files_actions_delete as "settings.files.actions.delete" }